const btnPallet = {
    // Primary
    primaryBase: "#4DA9E4",
    primaryHover: "#4089C1",
    primaryLight: "#EDF6FD",

    // Secondary
    secondaryBase: "#FE9D58",
    secondaryHover: "#F68554",
    secondaryLight: "#FFF5EE",

    // Tertiary
    tertiaryBase: "#6D7C94",
    tertiaryHover: "#506485",
    tertiaryLight: "#F7F6FB",

    // Success
    successBase: "#00C781",
    successHover: "#00B374",
    successLight: "#E5F9F2",

    // Danger
    dangerBase: "#FF4040",
    dangerHover: "#CC3333",
    dangerLight: "#FFEBEB",

    // Gray
    grayForBox: "#f4f4f5",
    grayForLine: "#e4e4e7",
    grayBaseForText: "#71717a",
    grayHoverForText: "#3f3f46",
    grayLightForText: "#d4d4d8",
}

export default btnPallet;
